export const seniorityLevels = [
  "internship",
  "juniorlevel",
  "midlevel",
  "seniorlevel",
  "principallevel",
  "techleader",
  "teamleader",
  "manager",
  "director",
  "head",
  "clevel",
  "cofounder",
];

export const seniorityLevelLabels: Record<string, { tr: string; en: string }> = {
  internship: { tr: 'Stajyer', en: 'Internship' },
  juniorlevel: { tr: 'Çaylak', en: 'Junior Level' },
  midlevel: { tr: 'Orta Seviye', en: 'Mid Level' },
  seniorlevel: { tr: 'Kıdemli', en: 'Senior Level' },
  principallevel: { tr: 'Baş Uzman', en: 'Principal Level' },
  techleader: { tr: 'Teknoloji Lideri', en: 'Tech Leader' },
  teamleader: { tr: 'Takım Lideri', en: 'Team Leader' },
  manager: { tr: 'Yönetici', en: 'Manager' },
  director: { tr: 'Direktör', en: 'Director' },
  head: { tr: 'Başkan', en: 'Head' },
  clevel: { tr: 'Üst Düzey', en: 'C Level' },
  cofounder: { tr: 'Kurucu Ortak', en: 'Co-founder' },
};

export const getSeniorityLevelLabel = (key: string, lang: 'tr' | 'en' = 'tr'): string => {
  return seniorityLevelLabels[key]?.[lang] || key;
};
